<template>
  <q-card class="row justify-between">
    <div class="col-lg-12 col-12 q-mt-x">
      <div class="q-ma-sm text-center q-ml-md">
        <span class="text-subtitle1 text-secondary text-bold">
          {{ title }}
        </span>
      </div>
      <div class="q-mx-xs q-pa-xs-xs">
        <q-separator />

        <q-list
          bordered
          separator
          class="text-bold text-subtitle2 q-pa-none q-ma-none"
        >
          <q-item>
            <q-item-section> Symbol</q-item-section>

            <q-separator vertical></q-separator>

            <q-item-section class="text-left q-ml-lg">
              {{ symbol ? symbol : "Not Avaliable" }}
            </q-item-section>
          </q-item>
          <q-item v-if="entry_point">
            <q-item-section>
              Entry Point
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <div class="row">
                <span v-if="buttonBuyOrSell != null">
                  {{ `${buttonBuyOrSell == "buy" ? "Above " : "Below "}` }}
                  &nbsp;
                </span>
                @

                {{ entry_point?.toFixed(2) }}
              </div>
            </q-item-section>
          </q-item>

          <q-item v-if="profit_target">
            <q-item-section>
              Profit Target
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <div class="row">
                <span v-if="buttonBuyOrSell != null">
                  {{ `${buttonBuyOrSell == "buy" ? "Above " : "Below "}` }}
                  &nbsp;
                </span>
                @
                {{ profit_target }}
                <span class="text-green text-subtitle2 q-pl-xs">
                  (
                  {{
                    (
                      ((profit_target - entry_point) / entry_point) *
                      100
                    ).toFixed(2)
                  }}
                  % )
                </span>
              </div>
            </q-item-section>
          </q-item>

          <q-item v-if="stop_loss">
            <q-item-section>
              Stop Loss

              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <div class="row">
                <span v-if="buttonBuyOrSell != null">
                  {{ `${buttonBuyOrSell == "buy" ? "Below " : "Above "}` }}
                  &nbsp;
                </span>
                @
                {{ stop_loss }}
                <span class="text-red text-subtitle2 q-pl-xs">
                  (
                  {{
                    (((stop_loss - entry_point) / entry_point) * 100).toFixed(2)
                  }}
                  % )
                </span>
              </div>
            </q-item-section>
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="risk_reward"
          >
            <q-item-section>
              Risk Reward Ratio
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <div class="row">
                1 : {{ risk_reward }}
                <!-- {{
                  (
                    (profit_target - entry_point) /
                    (entry_point - stop_loss)
                  ).toFixed(2)
                }} -->
              </div>
            </q-item-section>
          </q-item>

          <q-item v-if="volume">
            <q-item-section>
              Volume
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ volume }}</q-item-section
            >
          </q-item>

          <q-item v-if="avg_volume">
            <q-item-section>
              Avg Volume
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ avg_volume }}</q-item-section
            >
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="single_body_candle"
          >
            <q-item-section>
              {{
                tableType == "signal"
                  ? "Alert-Driven Candelstick"
                  : "Candelstick Type"
              }}
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ single_body_candle }}</q-item-section
            >
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="double_body_candle"
          >
            <q-item-section>
              {{
                tableType == "alert"
                  ? "Candelstick Type"
                  : "Alert-Driven Candelstick"
              }}
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ double_body_candle }}
            </q-item-section>
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="triple_body_candle"
          >
            <q-item-section>
              {{
                tableType == "alert"
                  ? "Candelstick Type"
                  : "Alert-Driven Candelstick"
              }}
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ triple_body_candle }}
            </q-item-section>
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="four_body_candle"
          >
            <q-item-section>
              {{
                tableType == "alert"
                  ? "Candelstick Type"
                  : "Alert-Driven Candelstick"
              }}
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ four_body_candle }}
            </q-item-section>
          </q-item>

          <q-item
            :class="this.$q.dark.mode === true ? ' bg-grey-9' : 'bg-green-1'"
            v-if="star_pattern"
          >
            <q-item-section>
              {{
                tableType == "alert"
                  ? "Candelstick Type"
                  : "Alert-Driven Candelstick"
              }}
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ star_pattern }}</q-item-section
            >
          </q-item>
          <q-item v-if="alert_date && tableType == 'signal'">
            <q-item-section>
              Alert Date
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <div class="row">
                {{
                  timePeriod === "hourly" ? convertDate(alert_date) : alert_date
                }}
              </div>
            </q-item-section>
          </q-item>

          <q-item v-if="date">
            <q-item-section>
              Date
              <!-- <q-item-label caption>Caption</q-item-label> -->
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              <q-item-label>
                {{ timePeriod === "hourly" ? convertDate(date) : date }}
              </q-item-label>
            </q-item-section>
          </q-item>

          <q-item v-if="open">
            <q-item-section class="text-bold">
              Open
              <!-- <q-item-label>Item with caption</q-item-label> -->
            </q-item-section>
            <q-separator vertical></q-separator>

            <q-item-section class="text-left q-ml-lg">
              {{ open }}
            </q-item-section>
          </q-item>

          <q-item v-if="high">
            <q-item-section class="">
              <!-- put overline to make it unbold -->
              High
            </q-item-section>
            <q-separator vertical></q-separator>

            <q-item-section class="text-left q-ml-lg">
              {{ high }}
            </q-item-section>
          </q-item>

          <q-item v-if="low">
            <q-item-section class="">
              <q-item-label>
                Low
                <span class="text-caption text-bold text-grey-9"> </span>
              </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>

            <q-item-section class="text-left q-ml-lg">
              {{ low }}
            </q-item-section>
          </q-item>

          <q-item v-if="close">
            <q-item-section>
              Close
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ close }}
            </q-item-section>
          </q-item>

          <q-item v-if="deviation">
            <q-item-section>
              Deviation
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ deviation }}
            </q-item-section>
          </q-item>

          <q-item v-if="ema55">
            <q-item-section>
              ema55
              <q-item-label overline> </q-item-label>
            </q-item-section>
            <q-separator vertical></q-separator>
            <q-item-section class="text-left q-ml-lg">
              {{ ema55 }}
            </q-item-section>
          </q-item>
        </q-list>

        <q-separator />
      </div>
    </div>
    <q-separator class="q-my-md" />
  </q-card>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import useCore from "src/use/core";
import useData from "src/use/data";
import moment from "moment";
import useMembership from "src/use/membership";
import StockwiseKeyValueComponents from "src/components/PriceActionSignals/StockwiseKeyValueComponents.vue";

export default {
  name: "StockWiseSignalStatus",
  components: {},
  props: {
    tableType: {
      type: String,
    },
    alert_date: { type: String },
    buttonBuyOrSell: {
      type: String,
      default: null,
    },
    title: {
      type: String,
    },
    symbol: {
      type: String,
    },
    date: {
      type: String,
    },
    open: {
      type: String,
    },
    high: {
      type: String,
    },
    low: {
      type: String,
    },
    close: {
      type: String,
    },
    deviation: {
      type: String,
    },
    ema55: {
      type: String,
    },
    single_body_candle: {
      type: String,
    },
    double_body_candle: {
      type: String,
    },
    triple_body_candle: {
      type: String,
    },
    four_body_candle: {
      type: String,
    },
    star_pattern: {
      type: String,
    },
    entry_point: {
      // type: String,
    },
    stop_loss: {
      // type: String,
    },
    profit_target: {
      // type: String,
    },
    risk_reward: {
      // type: String,
    },
    volume: {
      type: String,
    },
    avg_volume: {
      type: String,
    },
    timePeriod: {
      type: String,
      default: "daily",
    },
  },
  setup(props) {
    const convertDate = (date) => {
      const newDate = moment(date).format("YYYY-MM-DD, hh A");
      return newDate;
    };

    return {
      convertDate,
    };
  },
};
</script>
